export function QuestionnaireIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2048 2048"
      width="2em"
      height="2em"
    >
      <path
        fill="#3b5bfa"
        d="M1792 549v1499H128V0h1115zm-512-37h293l-293-293zm384 128h-512V128H256v1792h1408zm-512 256h384v384h-384zm128 256h128v-128h-128zm-896-128h640v128H384zm0-512h640v128H384zm768 896h384v384h-384zm128 256h128v-128h-128zm-896-128h640v128H384z"
      ></path>
    </svg>
  );
}
